// Wendy Fordham's coloring books. Add more objects here as new titles launch.
export const books = [
  {
    id: "skulls-and-skeletons",
    title: "Skulls & Skeletons",
    subtitle: "Gothic, sugar skull & Day of the Dead art for adults and teens.",
    price: "$8.79",
    format: "Paperback · 141 pages",
    tag: "Bestseller",
    accent: "#EF476F",
    cover: "https://m.media-amazon.com/images/I/71sX46JwhpL._SL1200_.jpg",
    amazon: "https://a.co/d/09OxtAJi",
    highlights: [
      "70 intricate designs — no repeats",
      "Large 8.5 x 11\" format",
      "Single-sided, resist bleed-through",
      "For adults & teens, all skill levels",
    ],
  },
  {
    id: "dragons-and-monsters",
    title: "Dragons & Monsters",
    subtitle: "Fierce dragons and imaginative monsters in high-detail fantasy art.",
    price: "$8.79",
    format: "Paperback · 140 pages",
    tag: "Fantasy",
    accent: "#118AB2",
    cover: "https://m.media-amazon.com/images/I/614wnWLRU-L._SL1200_.jpg",
    amazon: "https://a.co/d/0d1VsfRc",
    highlights: [
      "Winged, armored & fire-breathing dragons",
      "Intricate scales, wings, horns & claws",
      "Single-sided pages for framing",
      "A creative escape for fantasy lovers",
    ],
  },
  {
    id: "animal-adult",
    title: "Animal Adult Coloring Book",
    subtitle: "70 relaxing animal designs, from majestic lions to playful dolphins.",
    price: "$8.79",
    format: "Paperback · 140 pages",
    tag: "Animals",
    accent: "#06D6A0",
    cover: "https://m.media-amazon.com/images/I/61lQRYpPf9L._SL1200_.jpg",
    amazon: "https://a.co/d/06374raN",
    highlights: [
      "70 unique animal designs",
      "Lions, dolphins, birds & animal mandalas",
      "Large 8.5 x 11\" single-sided pages",
      "Stress relief & mindfulness",
    ],
  },
  {
    id: "unicorns-flowers",
    title: "Unicorns, Flowers & More",
    subtitle: "A whimsical mix of magical unicorns and blooming florals.",
    price: "$8.79",
    format: "Paperback · 140 pages",
    tag: "Whimsical",
    accent: "#F78C1F",
    cover: "https://m.media-amazon.com/images/I/61EGPgImqQL._SL1200_.jpg",
    amazon: "https://a.co/d/0aZtLxAz",
    highlights: [
      "Magical unicorns & enchanting florals",
      "70 single-sided pages",
      "Large 8.5 x 11\" format",
      "Perfect for adults & teens",
    ],
  },
  {
    id: "relax-and-unwind",
    title: "Relax & Unwind",
    subtitle: "Calming mandalas, nature, patterns & peaceful landscapes.",
    price: "$8.79",
    format: "Paperback · 140 pages",
    tag: "Relaxation",
    accent: "#8367C7",
    cover: "https://m.media-amazon.com/images/I/61TyNP5w1CL._SL1200_.jpg",
    amazon: "https://a.co/d/05e2ndsB",
    highlights: [
      "70 unique designs made with AI",
      "Mandalas, florals, patterns & landscapes",
      "140 single-sided pages",
      "Stress relief & creative meditation",
    ],
  },
  {
    id: "space-adult",
    title: "Space Adult Coloring Book",
    subtitle: "A cosmic journey of planets, galaxies, astronauts & constellations.",
    price: "$8.79",
    format: "Paperback · 139 pages",
    tag: "Cosmic",
    accent: "#3A86FF",
    cover: "https://m.media-amazon.com/images/I/611H0tDWfvL._SL1200_.jpg",
    amazon: "https://a.co/d/03BX0s7G",
    highlights: [
      "~70 original cosmic designs",
      "Planets, galaxies, spacecraft & more",
      "Medium to highly intricate detail",
      "Single-sided pages for framing",
    ],
  },
  {
    id: "space-kids",
    title: "Space Coloring Book for Kids",
    subtitle: "70 fun space scenes for young explorers ages 4–8.",
    price: "$8.79",
    format: "Paperback · 140 pages",
    tag: "For Kids",
    accent: "#FF6B6B",
    cover: "https://m.media-amazon.com/images/I/51OjeJvqlcL._SL1200_.jpg",
    amazon: "https://a.co/d/02BzBF60",
    highlights: [
      "70 engaging space illustrations",
      "Rockets, astronauts, aliens & planets",
      "Compact 8.5 x 8.5\" for small hands",
      "Single-sided pages for easy removal",
    ],
  },
  {
    id: "animal-fun-kids",
    title: "Animal Fun! Kids' Coloring Book",
    subtitle: "70 easy animal pages for little ones ages 3–8.",
    price: "$8.79",
    format: "Paperback · 140 pages",
    tag: "For Kids",
    accent: "#2EC4B6",
    cover: "https://m.media-amazon.com/images/I/51Wd6DC%2B5DL._SL1200_.jpg",
    amazon: "https://a.co/d/0fmzZEoy",
    highlights: [
      "70 adorable animals & critters",
      "Simple, bold line art for little hands",
      "Builds focus & fine motor skills",
      "Single-sided 8.5 x 8.5\" pages",
    ],
  },
  {
    id: "farm-kids",
    title: "Farm Coloring Book",
    subtitle: "70 charming farm scenes for kids ages 3–8.",
    price: "$9.99",
    format: "Paperback · 140 pages",
    tag: "For Kids",
    accent: "#FB8500",
    cover: "https://m.media-amazon.com/images/I/51UMbxy5waL._SL1200_.jpg",
    amazon: "https://a.co/d/01oqBbGC",
    highlights: [
      "70 cute farm-themed illustrations",
      "Animals, tractors, barns & crops",
      "Easy drawings for small hands",
      "Single-sided 8.5 x 8.5\" pages",
    ],
  },
  {
    id: "dogs-and-cats-kids",
    title: "Dogs and Cats Coloring Book",
    subtitle: "70 adorable dogs & cats for young animal lovers ages 4+.",
    price: "$8.79",
    format: "Paperback · 140 pages",
    tag: "For Kids",
    accent: "#9B5DE5",
    cover: "https://m.media-amazon.com/images/I/51KInkCajIL._SL1200_.jpg",
    amazon: "https://a.co/d/0anDf6cB",
    highlights: [
      "70 cute dogs & cats to color",
      "Simple, playful designs for kids",
      "Builds creativity & fine motor skills",
      "Single-sided 8.5 x 8.5\" pages",
    ],
  },
];
